<template>
  <div>
    <v-container container--fluid>
      <v-row class="px-4">
        <h1>Tracking errors</h1>
      </v-row>

      <v-row justify="space-between">
        <v-col cols="4" md="3">
          <v-text-field
            label="Search..."
            v-model="search"
            prepend-inner-icon="search"
          ></v-text-field>
        </v-col>

        <v-col cols="4" md="2">
          <DatePicker
            ref="date"
            label="Load tracking errors from"
            prepend-inner-icon="fas fa-calendar"
            :special-style="false"
            :date_props="dateFrom"
            @interface="(event) => {dateFrom = event} "
          ></DatePicker>
        </v-col>


        <v-col cols="4" md="2">
          <DatePicker
            ref="date"
            label="Load tracking errors to"
            prepend-inner-icon="event"
            :special-style="false"
            :clearable="true"
            :date_props="dateTo"
            @interface="(event) => {dateTo = event} "
          ></DatePicker>
        </v-col>


        <v-col cols="4" md="2">
          <v-autocomplete
            clearable
            :items="clients"
            v-model="clientSelected"
            item-value="id"
            item-text="name"
            label="Pick a client..."
            prepend-icon="fas fa-user"
          >
          </v-autocomplete>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="2" md="2">
          <v-menu offset-y>
            <template v-slot:activator="{ on: menuList }">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn  icon x-large  color="blue darken-1" v-on="menuList" class="white--text">
                    <v-icon  v-on="tooltip">cloud_download</v-icon>
                  </v-btn>
                </template>
                <span>Export CSV</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item
                v-for="(choice, index) in exportChoices"
                :key="index"
              >
                <v-list-item-icon>
                  <v-btn icon large>
                    <v-icon :color="choice.color" @click="csvExport(index)">cloud_download</v-icon>
                  </v-btn>
                </v-list-item-icon>
                <v-list-item-title>{{choice.text}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tooltip top color="secondary" v-if="errorAdmin">
            <template v-slot:activator="{  on, attrs }">
              <v-btn x-large text v-bind="attrs"  v-on="on" color="green" dark @click="displayGenerateReport=true"
              >
                <v-icon class="mr-2">fas fa-list-ul</v-icon>
              </v-btn>
            </template>
            <span>Genreate Reports</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>

    <v-tabs
      v-model="tab"
      grow
    >
      <v-tab key="unverified">
        <v-icon color="red" small class="mr-2">fas fa-times</v-icon> Unverified
      </v-tab>
      <v-tab key="verified">
        <v-icon color="green" small class="mr-2">fas fa-check</v-icon> Verified
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item key="unverified">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="renderedErrorsUnverified"
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}"
                @click="displayInfo(props.item)">
              <td class="text-center" v-if="header.text !== 'Actions'" v-for="(header, index) in headers"
                  :key="index">{{props.item[header.value]}}
              </td>
              <td class="text-center" v-if="isInternalUser">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon @click.stop="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                      delete
                    </v-icon>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-tab-item>

      <v-tab-item key="verified">
        <v-data-table
          :search="search"
          :headers="headers"
          :items="renderedErrorsVerified"
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}"
                @click="displayInfo(props.item)">
              <td class="text-center" v-if="header.text !== 'Actions'"  v-for="(header, index) in headers"
                  :key="index">{{props.item[header.value]}}
              </td>
              <td class="text-center" v-if="isInternalUser">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon @click.stop="deleteRow(props.item)" color="red" v-on="on" class="pl-1">
                      delete
                    </v-icon>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-tab-item>
    </v-tabs-items>


    <DeliveryInfoDisplayer
      :tracking="selectedTrackingNumber"
      :showProp="showInfo"
      v-on:close="showInfo=false"
      :displayShowDialog="displayShowDialog"
      :isTrackingErrors="isTrackingErrors"
      v-on:approving="approving"
      v-on:denying="denying"
    ></DeliveryInfoDisplayer>

    <v-dialog
      v-model="approvedDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>You have approved this tracking error</h3>
        </v-card-title>
        <v-card-actions class="flex-column">
          <v-row style="width: 100%">
            <v-col cols="12" class="justify-center flex-column">
              <v-select
                label="Choose a reason code"
                :items="errorTypes"
                item-text="text"
                v-model="errorType"
                prepend-icon="fas fa-exclamation-circle"
                return-object
                @input="fault = errorType.fault; editedItem.code_actual = errorType.value"
              ></v-select>
              <v-select
                label="Choose a source error"
                :items="fault"
                item-text="text"
                item-value="value"
                v-model="editedItem.fault_code"
                prepend-icon="fas fa-truck"
                :disabled="!errorType"
              ></v-select>
              <v-textarea
                counter="250"
                v-model="editedItem.comments"
                label="Tell us more about this error..."
                prepend-icon="far fa-comment"
              >
              </v-textarea>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="6">
              <v-btn text @click="closeApproveDialog" color="blue-grey lighten-2">Close</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn text @click="approveTrackingError" color="green">Approve</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deniedDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>You have denied this tracking error</h3>
        </v-card-title>
        <v-card-actions class="flex-column">

          <v-row style="width: 100%">
            <v-col cols="12" class="justify-center flex-column">
              <v-autocomplete
                :items="rejectReasons"
                item-text="text"
                v-model="rejectReason"
                label="Reject Reason"
                return-object
                @input="editedItem.reject_reason = rejectReason.value"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row style="width: 100%">
            <v-col cols="12">
              <v-textarea
                counter="250"
                v-model="editedItem.comments"
                label="Tell us more about this error..."
                prepend-icon="far fa-comment"
              >
              </v-textarea>
            </v-col>
          </v-row>



          <v-row>
            <v-col cols="6">
              <v-btn text @click="closeDenyDialog" color="blue-grey lighten-2">Close</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn text @click="denyTrackingError" color="red">DENY</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this tracking delivery error.<br>
          This action cannot be undone.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="deleteDialog=false">Cancel Deletion</v-btn>
          <v-btn text color="red" @click="DeleteDeliveryError">Delete Delivery Error</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="displayGenerateReport"
      max-width="800px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>Reports</h3>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="blue darken-1 headline" text v-on="on" >
                <span class="v-btn__content" style="font-size: 22px;">?</span>
              </v-btn>
            </template>
            <span>You can select the from date and to date, which the period you can choose is within 7 days<br>
          Currently four reports can be generated.</span>
          </v-tooltip>
          <v-btn icon @click="displayGenerateReport=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          <v-row style="width: 100%">
            <v-col cols="8" md="5">
              <DatePicker
                ref="date"
                label="Load errors from"
                prepend-inner-icon="fas fa-calendar"
                :special-style="false"
                :date_props="reportDateFrom"
                @interface="(event) => {reportDateFrom = event} "
              ></DatePicker>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="8" md="5">
              <DatePicker
                ref="date"
                label="Load errors to"
                prepend-inner-icon="fas fa-calendar"
                :special-style="false"
                :date_props="reportDateTo"
                @interface="(event) => {reportDateTo = event} "
              ></DatePicker>
          </v-col>
          </v-row>
          <v-row style="width: 100%">
            <v-col cols="12" md="5" style="text-align: center">
              <v-btn text color="warning"  @click="errorsExport()">
                <v-icon class="mr-2">fas fa-list-ul</v-icon>
                Errors
              </v-btn>
            </v-col>
            <v-col cols="12" md="5" style="text-align: center">
              <v-btn text dark color="indigo"  @click="errorsContractorsExport()">
                <v-icon class="mr-2">fas fa-list-ul</v-icon>
                Errors contractors
              </v-btn>
            </v-col>
            <v-row style="width: 100%">
              <v-col cols="12" md="6" style="text-align: center"  >
                <v-btn text color="green" dark @click="errorsDepotsExport()">
                  <v-icon class="mr-2">fas fa-list-ul</v-icon>
                  Errors depots
                </v-btn>
              </v-col>
              <v-col cols="12" md="4" style="text-align: left">
                <v-btn text color="warning"  @click="errorsContractorsUsersExport()">
                  <v-icon class="mr-2">fas fa-list-ul</v-icon>
                  Errors contractors users
                </v-btn>
              </v-col>
            </v-row>


          </v-row>

        </v-card-text>
<!--        <v-card-actions class="justify-center">-->
<!--          <v-row>-->
<!--            <v-btn text color="blue-grey lighten-2" @click="deleteDialog=false">Cancel Deletion</v-btn>-->
<!--            <v-btn text color="red" @click="DeleteDeliveryError">Delete Delivery Error</v-btn>-->
<!--          </v-row>-->
<!--        </v-card-actions>-->
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment';
    import DeliveryInfoDisplayer from './Search/DeliveryInfoDisplayer'
    import DatePicker from "../../parts/DatePicker";
    import {trim} from "leaflet/src/core/Util";

    export default {
      name: "ErrorTracking",
      components: {
        DeliveryInfoDisplayer,
        DatePicker
      },
      data() {
          return {
              errors: [],
              search: '',
              modalDateFrom: false,
              modalDateTo: false,
              dateFrom: moment().subtract(14, "days").format("YYYY-MM-DD"),
              dateTo: null,
              reportDateFrom: moment().subtract(7, "days").format("YYYY-MM-DD"),
              reportDateTo: null,
              clients: null,
              clientSelected: null,
              loading: false,
              reload: false,
              tab: 0,
              headers: [
                //  {text: 'Source', value: 'source', align: 'center', sortable: true},
                  {text: 'Tracking', value: 'tracking', align: 'center', sortable: true},
                  {text: 'Code Source', value: 'code_source', align: 'center', sortable: true},
                  {text: 'Comments', value: 'comments', align: 'center', sortable: false},
                  {text: 'Code Actual', value: 'code_actual', align: 'center', sortable: true},
                  //{text: 'Cutomer Complaint', value: 'complaint', align: 'center', sortable: true},
                  {text: 'Notes', value: 'notes', align: 'center', sortable: false},
                  {text: 'Fault Code', value: 'fault_code', align: 'center', sortable: true},
                  {text: 'Temperature', value: 'temperature', align: 'center', sortable: true},
                  {text: 'Created at', value: 'actual_time', align: 'center', sortable: true},
                  {text: 'Approved', value: 'approved', align: 'center', sortable: true},
                  {text: 'verified at', value: 'verified_at', align: 'center', sortable: true},
                  {text: 'verified by', value: 'verified_by', align: 'center', sortable: true},
                  {text: 'Actions', value: 'actions', align: 'center', sortable: false},
              ],
              showInfo: false,
              selectedTrackingNumber: null,
              isTrackingErrors: true,
              approvedDialog: false,
              deniedDialog: false,
              source: null,
              fault: [],
              errorType: null,
              codeSource: null,
              deleteDialog: false,
              toBeDeleted: null,
              editedItem: {
                  code_actual: null,
                  comments: null,
                  source: null,
                  serial: null,
                  reject_reason: null,
                  fault_code: {text: "Driver", value: 'DR'},
              },
              default: {
                  code_actual: null,
                  comments: null,
                  source: null,
                  serial: null,
                  reject_reason: null,
                  fault_code: null,
              },
            exportChoices: [
              {text: 'Errors Verified', value: 'errors verified', color: 'rgb(105,255,128)'},
              {text: 'Errors Unverified', value: 'errors unverified', color: 'rgb(255,229,95)'}
            ],
            csvErrorsFormat:[],
            rejectReason:'',
            rejectReasons:[
              {text: 'BAD ADDRESS', value: 'BA'},
              {text: 'GOODS NOT RECEIVED', value: 'GNR'},
              {text: 'CORRECT DELIVERY', value: 'CD'},
              {text: 'DELIVERED WITHIN 1 HR OF TIME WINDOW', value: 'DW1H'},
              {text: 'INVALID INSTRUCTIONS FOR AM SLOT', value: 'IIFS'},
              {text: 'INVALID INSTRUCTIONS', value: 'II'},
              {text: 'FOR REVIEW', value: 'FR'}
            ],
            errorVerfied:[],
            errorUnverfied:[],
            isVerfied:false,
            displayGenerateReport:false,
          }
      },
      mounted: function () {
          this.getClients();
      },
      computed : {
        errorAdmin() {
          return this.$store.getters['auth/hasPermission']('errors_admin');
        },
        renderedErrorsVerified() {
          if (this.Errors === null || this.Errors === undefined) {
            return [];
          } else {
            //this.Errors.filter((elt) => elt.verified === true );
            return this.Errors.filter((elt) => elt.verified == 1).map((elt) => this.formatTemperature(elt));
          }
        },
        renderedErrorsUnverified() {
          if (this.Errors === null || this.Errors === undefined) {
            return [];
          } else {
            return this.Errors.filter((elt) => elt.verified == 0).map((elt) => this.formatTemperature(elt));
          }
        },
        errorTypes() {
        let errorTypes = [
          {
            text: 'Delivered to wrong address',
            value: 'D',
            fault: [
              {text: "Driver", value: 'DR'},
              {text: "Router", value: 'RP'}

            ]
          },
          {
            text: 'Instructions Not Followed',
            value: 'IN',
            fault: [{text: "Driver", value: 'DR'}
                  ]
          },
          {text: 'Time Window Error',
            value: 'TW',
            fault: [
              {text: "Driver", value: 'DR'},
              {text: "Linehaul", value: 'LH'},
              {text: "Unknown source", value: 'UN'}
            ]
          },
          {
            text: 'Stolen',
            value: 'ST',
            fault: [
              {text: "Unknown source", value: 'UN'}
            ]
          },
          {
            text: 'Damaged Box',
            value: 'DT',
            fault: [
              {text: "Driver", value: 'DR'},
              {text: "Unknown source", value: 'UN'}

            ]
          },
          {
            text: 'Driver Behaviour',
            value: 'B',
            fault: [
              {text: "Driver", value: 'DR'}

            ]
          },
          {
            text: 'Property Damage',
            value: 'P',
            fault: [
              {text: "Driver", value: 'DR'}

            ]
          },
          {
            text: 'Pick-Pack',
            value: 'PIK',
            fault: [
              {text: "Pick-Pack", value: 'PP'}

            ]
          }

        ];
        if (this.isInternalUser) {
          errorTypes.push(
            {
              text: 'Mis sort',
              value: 'MS',
              fault: [
                {text: "Driver", value: 'DR'},
                {text: "Warehouse", value: 'WH'}

              ]
            },
            {
              text: 'Routing Issue',
              value: 'R',
              fault: [
                {text: "Router", value: 'RP'}

              ]
            },
            {
              text: 'Technical Issue',
              value: 'IT',
              fault: [
                {text: "Router", value: 'RP'},
                {text: "Tech", value: 'IT'}

              ]
            },
            {
              text: 'No POD / Insufficient POD',
              value: 'PO',
              fault: [
                {text: "Driver", value: 'DR'},
                {text: "Tech", value: 'IT'}

              ]
            },
            {
              text: 'General Error',
              value: 'GE',
              fault: [
                {text: "Driver", value: 'DR'},
                {text: "Warehouse", value: 'WH'},
                {text: "Router", value: 'RP'},
                {text: "Linehaul", value: 'LH'},
                {text: "Tech", value: 'IT'},
                {text: "Unknown source", value: 'UN'}

              ]
            },
            {
              text: 'Unnecessary Returns',
              value: 'UR',
              fault: [
                {text: "Driver", value: 'DR'}
              ]
            },
          );
        }
        return errorTypes;
      }
      },
      methods: {
        isInternalUser() {
            return this.$store.getters['auth/isInternalUser'];
        },
        csvExport(id){
          if(id == 0){
            this.isVerfied = 1;
          } else this.isVerfied = 0;

          let suffix = '';
          if (this.dateFrom !== null) {
            if (this.dateTo !== null) {
              if (this.clientSelected !== null && this.clientSelected !== undefined) {
                suffix = '/errors/csv?key=' + encodeURI(this.$store.state.auth.key) + '&from=' + this.dateFrom + '&to=' + this.dateTo + '&clientId=' + this.clientSelected
                  + '&verified=' + this.isVerfied;
              } else {
                suffix = '/errors/csv?key=' + encodeURI(this.$store.state.auth.key) + '&from=' + this.dateFrom + '&to=' + this.dateTo +'&verified=' + this.isVerfied;
              }
            } else if (this.clientSelected !== null && this.clientSelected !== undefined) {
              suffix = '/errors/csv?key=' + encodeURI(this.$store.state.auth.key)+ '&from=' + this.dateFrom + '&clientId=' + this.clientSelected +'&verified=' + this.isVerfied;
            } else {
              suffix = '/errors/csv?key=' + encodeURI(this.$store.state.auth.key) + '&from=' + this.dateFrom +'&verified=' + this.isVerfied;
            }
          }
          window.open(process.env.API_URL + suffix, '_blank');
        },
        reloadErrorTabs() {
          this.reload = !this.reload;
        },
        showApproved(errors){
          for( var key in errors){
            if(errors[key]['approved'] === 0){
              errors[key]['approved'] = 'False';
            } else if(errors[key]['approved'] === 1){
              errors[key]['approved'] = 'True';
            }
          }
        },
        getClients() {
            axios.get(process.env.API_URL + '/clients?inactive=true')
                .then((response) => {
                    this.clients = response.data;
                })
                .catch((error) => {
                    console.log(error.response.error);
                })
        },
        formatTemperature(item) {
            // Route22 sends 999 or 99.9 as sentinels meaning no temperature was taken
            const temperature = item.temperature;
            const formatted = (temperature === null || temperature === undefined || temperature === 999 || temperature === 99.9) ? '' : temperature + '°C';
            return Object.assign({}, item, {temperature: formatted});
        },
        displayInfo(item) {
            this.errorType = this.errorTypes.filter(error => error.value === item.code_source)[0];
            if (this.errorType){
              this.fault = this.errorType.fault;
            } else{
              this.fault = [
                {text: "Driver", value: 'DR'},
                {text: "Warehouse", value: 'WH'},
                {text: "Router", value: 'RP'},
                {text: "Linehaul", value: 'LH'},
                {text: "Tech", value: 'IT'},
                {text: "Unknown source", value: 'UN'},
              ];
            }
            this.selectedTrackingNumber = item.tracking;
            this.editedItem.code_source = item.code_source;
            this.editedItem.code_actual = item.code_source;
            this.editedItem.comments = item.notes;
            this.editedItem.fault_code = item.fault_code;
            this.editedItem.source = item.source;

            this.codeSource = item.code_source;
            this.showInfo = true;
        },
        displayShowDialog() {
            this.showInfo = true;
        },
        approving() {
            this.approvedDialog = true;
        },
        denying() {
            this.rejectReason = null;
            this.deniedDialog = true;
        },
        deleteRow(item) {
            this.toBeDeleted = item.tracking;
            this.deleteDialog = true;
        },
        DeleteDeliveryError() {
            axios.delete(process.env.API_URL + '/errors/' + this.toBeDeleted)
                .then((response) => {
                    this.toBeDeleted = null;
                    this.deleteDialog = false;
                    this.$store.commit('displaySnackbar', 'Delete successful');
                    this.reloadErrorTabs();
                })
                .catch((error) => {
                    this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                });
        },
        closeApproveDialog() {
            this.editedItem = Object.assign({}, this.default);
            this.selectedTrackingNumber = null;
            this.errorType = null;
            this.codeSource = null;
            this.fault = [];
            this.approvedDialog = false;
        },
        closeDenyDialog() {
            this.editedItem = Object.assign({}, this.default);
            this.selectedTrackingNumber = null;
            this.errorType = null;
            this.codeSource = null;
            this.fault = [];
            this.deniedDialog = false;
        },
        approveTrackingError() {

            if(this.editedItem.code_actual === null|| this.editedItem.fault_code === null){
                this.$store.commit('displaySnackbar', 'Please select a source and a reason code');
                return null;
            } else {
                let body = {
                    source: this.editedItem.source,
                    fault_code: this.editedItem.fault_code,
                    comments: this.editedItem.comments,
                    code_source: this.editedItem.code_source,
                    code_actual: this.editedItem.code_actual,
                    approved: true,
                    verified: true,
                };

                axios.put(process.env.API_URL + '/errors/' + this.selectedTrackingNumber, body)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Changes saved');
                        this.reloadErrorTabs();
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    });

                this.closeApproveDialog();
            }

        },
        denyTrackingError() {
            let body = {
                source: this.editedItem.source,
                code_source: this.editedItem.code_source,
                comments: this.editedItem.comments,
                reject_reason: this.editedItem.reject_reason,
                code_actual: null,
                approved: false,
                verified: true,
            };

            axios.put(process.env.API_URL + '/errors/' + this.selectedTrackingNumber, body)
                .then((response) => {
                    this.$store.commit('displaySnackbar', 'Changes saved');
                    this.reloadErrorTabs();
                })
                .catch((error) => {
                    this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                });
            this.closeDenyDialog();
        },
        errorsExport(){
          let suffix = '&from=' + this.reportDateFrom + '&to=' + this.reportDateTo;
          if(!this.validDate(this.reportDateFrom,this.reportDateTo)) return false;
          window.open(process.env.API_URL + '/errors/reports/errors?key=' + encodeURI(this.$store.state.auth.key) + suffix, '_blank');
        },
        errorsContractorsExport(){
          let suffix = '&from=' + this.reportDateFrom + '&to=' + this.reportDateTo;
          if(!this.validDate(this.reportDateFrom,this.reportDateTo)) return false;
          window.open(process.env.API_URL + '/errors/reports/errorscontractors?key=' + encodeURI(this.$store.state.auth.key) + suffix, '_blank');
        },
        errorsDepotsExport(){
          let suffix = '&from=' + this.reportDateFrom + '&to=' + this.reportDateTo;
          if(!this.validDate(this.reportDateFrom,this.reportDateTo)) return false;
          window.open(process.env.API_URL + '/errors/reports/errorsdepots?key=' + encodeURI(this.$store.state.auth.key) + suffix, '_blank');
        },
        errorsContractorsUsersExport(){
          let suffix = '&from=' + this.reportDateFrom + '&to=' + this.reportDateTo;
          if(!this.validDate(this.reportDateFrom,this.reportDateTo)) return false;
          window.open(process.env.API_URL + '/errors/reports/errorscontractorsusers?key=' + encodeURI(this.$store.state.auth.key) + suffix, '_blank');
        },
        validDate(fromDate,toDate){

          if (!toDate){
            this.$store.commit('displaySnackbar', 'please select the to date');
            return false;
          }
          let reg = new RegExp('_','g');
          let from = new Date(fromDate);
          let to = new Date(toDate);
          let diff = Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));

          if ((new Date(fromDate.replace(reg,'/'))) > (new Date(toDate.replace(reg,'/')))){
             this.$store.commit('displaySnackbar', 'from date can not later than the to date');
             return false;
          } else if (diff  > 8){
             this.$store.commit('displaySnackbar', 'period more than 7 days');
             return false;
          }
          return true;
        }
      },
      asyncComputed: {
        async Errors() {
          this.loading = true;
          if (this.reload || !this.reload) {
            let suffix = '';
            if (this.dateFrom !== null) {
              if (this.dateTo !== null) {
                if (this.clientSelected !== null && this.clientSelected !== undefined) {
                  suffix = '/errors?from=' + this.dateFrom + '&to=' + this.dateTo + '&clientId=' + this.clientSelected;
                } else {
                  suffix = '/errors?from=' + this.dateFrom + '&to=' + this.dateTo;
                }
              } else if (this.clientSelected !== null && this.clientSelected !== undefined) {
                suffix = '/errors?from=' + this.dateFrom + '&clientId=' + this.clientSelected;
              } else {
                suffix = '/errors?from=' + this.dateFrom;
              }

              return await axios.get(process.env.API_URL + suffix)
                .then((response) => {
                  this.loading = false;

                  this.showApproved(response.data);
                  return response.data;
                })
                .catch((error) => {
                  console.log(error);
                  this.$store.commit('displaySnackbar', 'ERROR ' + (error.response ? error.response.data.error : 'Unknown error'));
                  this.loading = false;
                  return [];
                })
            } else {
              this.$store.commit('displaySnackbar', 'Please enter a date');
            }
          }
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ErrorTracking.vue